// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");

let validators_attachments = {
  strategy: "OnFirstChange",
  validate: param => {
    let attachments = param.attachments;
    let uploadedAttachments = Stdlib_Array.filterMap(attachments, x => {
      let attachment = x.state;
      if (attachment.TAG === "Success") {
        return attachment._0;
      }
    });
    if (uploadedAttachments.length === attachments.length) {
      return {
        TAG: "Ok",
        _0: uploadedAttachments
      };
    } else if (attachments.some(x => {
        switch (x.state.TAG) {
          case "NotStarted" :
          case "InProgress" :
            return true;
          case "Failed" :
          case "Success" :
            return false;
        }
      })) {
      return {
        TAG: "Error",
        _0: "UPLOAD_FAILED"
      };
    } else {
      return {
        TAG: "Error",
        _0: "UPLOAD_IN_PROGRESS"
      };
    }
  }
};

let validators_text = {
  strategy: "OnFirstChange",
  validate: param => {
    let text = param.text.trim();
    if (text === "") {
      if (param.attachments.length !== 0) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: "EMPTY_MESSAGE"
        };
      }
    } else {
      return {
        TAG: "Ok",
        _0: text
      };
    }
  }
};

let validators = {
  attachments: validators_attachments,
  text: validators_text
};

function initialFieldsStatuses(input) {
  return {
    attachments: "Pristine",
    text: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    attachments: "Pristine",
    text: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      attachments: "Pristine",
      text: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.attachments;
  let tmp;
  tmp = typeof match !== "object" ? validators.attachments.validate(input) : match._0;
  let match$1 = fieldsStatuses.text;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.text.validate(input) : match$1._0;
  let attachmentsResult = tmp;
  let attachmentsResult$1;
  if (attachmentsResult.TAG === "Ok") {
    let textResult = tmp$1;
    if (textResult.TAG === "Ok") {
      return {
        TAG: "Valid",
        output: {
          text: textResult._0,
          attachments: attachmentsResult._0
        },
        fieldsStatuses: {
          attachments: {
            TAG: "Dirty",
            _0: attachmentsResult,
            _1: "Shown"
          },
          text: {
            TAG: "Dirty",
            _0: textResult,
            _1: "Shown"
          }
        },
        collectionsStatuses: undefined
      };
    }
    attachmentsResult$1 = attachmentsResult;
  } else {
    attachmentsResult$1 = attachmentsResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      attachments: {
        TAG: "Dirty",
        _0: attachmentsResult$1,
        _1: "Shown"
      },
      text: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurAttachmentsField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.attachments, validators_attachments, status => {
            let init = state.fieldsStatuses;
            return {
              attachments: status,
              text: init.text
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTextField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.text, validators_text, status => {
            let init = state.fieldsStatuses;
            return {
              attachments: init.attachments,
              text: status
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateAttachmentsField" :
          let nextInput = action._0(state.input);
          let nextFieldsStatuses = {
            contents: state.fieldsStatuses
          };
          let result$2 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.text, validators_text, status => {
            let init = nextFieldsStatuses.contents;
            return {
              attachments: init.attachments,
              text: status
            };
          });
          if (result$2 !== undefined) {
            nextFieldsStatuses.contents = result$2;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, nextFieldsStatuses.contents.attachments, state.submissionStatus, validators_attachments, status => {
                let init = nextFieldsStatuses.contents;
                return {
                  attachments: status,
                  text: init.text
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTextField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.text, state.submissionStatus, validators_text, status => {
                let init = state.fieldsStatuses;
                return {
                  attachments: init.attachments,
                  text: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  attachments: "Pristine",
                  text: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  attachments: "Pristine",
                  text: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateAttachments: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateAttachmentsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateText: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTextField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurAttachments: () => dispatch("BlurAttachmentsField"),
    blurText: () => dispatch("BlurTextField"),
    attachmentsResult: Formality.exposeFieldResult(state.fieldsStatuses.attachments),
    textResult: Formality.exposeFieldResult(state.fieldsStatuses.text),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.attachments;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.text;
      return typeof tmp$1 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

function useWithAttachments(onSubmit, onUnsupportedFileError) {
  let clearAttachments = React.useRef(undefined);
  let form = useForm({
    text: "",
    attachments: []
  }, (state, param) => {
    let reset = param.reset;
    let reset$1 = () => {
      reset();
      Stdlib_Option.getOr(Stdlib_Option.map(clearAttachments.current, f => f()), undefined);
    };
    onSubmit(state, reset$1, param.notifyOnFailure, param.notifyOnSuccess);
  });
  let attachments$p = Attachments.useAttachments(attachments => form.updateAttachments((input, attachments) => ({
    text: input.text,
    attachments: attachments
  }), Stdlib_List.toArray(attachments)), Stdlib_List.fromArray(form.input.attachments), onUnsupportedFileError);
  React.useEffect(() => {
    clearAttachments.current = attachments$p.clearAll;
  }, []);
  return [
    form,
    attachments$p
  ];
}

let initialCollectionsStatuses;

exports.validators = validators;
exports.initialFieldsStatuses = initialFieldsStatuses;
exports.initialFieldStatuses_xxx = initialFieldStatuses_xxx;
exports.initialCollectionsStatuses = initialCollectionsStatuses;
exports.initialState = initialState;
exports.validateForm = validateForm;
exports.useForm = useForm;
exports.useWithAttachments = useWithAttachments;
/* react Not a pure module */
